import './notification.scss';
import PropTypes from 'prop-types';
import { FiCheckCircle, FiInfo, FiAlertTriangle, FiXCircle, FiX } from 'react-icons/fi'; // Importing relevant icons
import React, { useState } from 'react';

const Notification = ({ notification, onDismiss }) => {
  const { id, type, message } = notification;
  const [isFadingOut, setIsFadingOut] = useState(false);

  // Determine icon based on notification type
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FiCheckCircle />;
      case 'error':
        return <FiXCircle />;
      case 'info':
        return <FiInfo />;
      case 'warning':
        return <FiAlertTriangle />;
      default:
        return <FiInfo />;
    }
  };

  const handleClose = () => {
    setIsFadingOut(true);
    // Wait for the fade-out animation to finish before dismissing
    setTimeout(() => {
      onDismiss(id);
    }
    , 500); // Duration should match the fadeOut animation duration in SCSS
  };

  return (
    <div className={`notification ${type} ${isFadingOut ? 'fade-out' : ''}`} role="alert" aria-live="assertive">
      <span className="notification-icon">{getIcon()}</span>
      <div className="notification-message">{message}</div>
      <button className="notification-close" aria-label="Close Notification" onClick={handleClose}>
        <FiX />
      </button>
    </div>
  );
};

Notification.propTypes = {
  notification: PropTypes.shape({
    id: PropTypes.any.isRequired,
    type: PropTypes.oneOf(['success', 'error', 'info', 'warning']).isRequired,
    message: PropTypes.string.isRequired,
  }).isRequired,
};

export default Notification;